import { render, staticRenderFns } from "./BaseFormFieldV2.vue?vue&type=template&id=281e6fb2"
import script from "./BaseFormFieldV2.vue?vue&type=script&lang=js"
export * from "./BaseFormFieldV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports